import React, { useState } from "react";
import {
  BaseEdge,
  EdgeLabelRenderer,
  type EdgeProps,
  getSmoothStepPath,
} from "@xyflow/react";

export const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  style = {},
}: EdgeProps) => {
  const [showColorPicker, setShowColorPicker] = useState<boolean>(false);

  const colors = ["#0077ff", "#ff0073", "#00ff73", "#ff7700", "#7700ff"]; // Paleta de cores

  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <>
      {/* Renderiza a edge como smoothstep */}
      <g
        onClick={() => setShowColorPicker(!showColorPicker)}
        style={{ cursor: "pointer" }}
      >
        <BaseEdge
          path={edgePath}
          style={{
            ...style,
            stroke: (data?.color as string) || "#0077ff", // Usa a cor do `data.color`
            strokeWidth: 4,
          }}
        />
      </g>

      {/* Modal de seleção de cor */}
      {showColorPicker && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: "absolute",
              transform: `translate(-50%, -50%) translate(${
                (sourceX + targetX) / 2
              }px, ${(sourceY + targetY) / 2}px)`,
              background: "white",
              padding: "12px",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              display: "flex",
              gap: "12px",
              zIndex: 10,
              pointerEvents: "all",
            }}
            className="nodrag nopan"
            onClick={(e) => e.stopPropagation()}
          >
            {colors.map((c) => (
              <button
                key={c}
                onClick={(e) => {
                  e.stopPropagation();
                  // Atualiza a cor no estado global usando o callback `onEdgesChange`
                  if (data) data.color = c;
                  setShowColorPicker(false);
                }}
                style={{
                  backgroundColor: c,
                  border: "none",
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  cursor: "pointer",
                }}
              />
            ))}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};
